export default function TrustSection() {
  const trustItems = [
    {
      icon: 'ri-refresh-line',
      title: 'Updated Daily',
      desc: 'Real-time price tracking and inventory updates across all listed products.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Listings',
      desc: 'Every product passes our multi-point verification before appearing in spreadsheets.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Price Compared',
      desc: 'Cross-platform price analysis ensures you always get the best available deal.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Beginner Friendly',
      desc: 'No technical knowledge needed — just browse, compare, and buy with confidence.',
    },
    {
      icon: 'ri-spam-line',
      title: 'Scam Filtered',
      desc: 'Our team actively removes suspicious listings to keep your shopping safe.',
    },
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-3">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 max-w-md leading-tight">
            Why Our<br />Spreadsheets Win
          </h2>
          <p className="text-sm text-foreground-500 max-w-sm">
            Daily verified, price-compared, and scam-filtered
          </p>
        </div>

        {/* Trust Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl p-6 flex flex-col hover:bg-background-200/70 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-2">{item.title}</h4>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}